import debounce from "lodash.debounce";

import { ButtonControl } from "@/Common/Components/Buttons/ButtonControl";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";

interface IPaginationViewControlProps {
    itemCount: number;
    absoluteIndex: number;
    isLastItem?: boolean;
    isPreviousButtonDisabled: boolean;
    onPreviousItemClick: () => void;
    onNextItemClick: () => void;
    onLastItem?: () => void;
}

function PaginationViewControl(props: Readonly<IPaginationViewControlProps>): JSX.Element {
    const { getText } = useTranslation();

    const onPreviousItemClick = debounce(() => {
        props.onPreviousItemClick();
    }, 300);

    const onNextItemClick = debounce(() => {
        if (props.isLastItem)
            props.onLastItem?.();

        props.onNextItemClick();
    }, 300);

    return (
        <>
            <ButtonControl
                onClick={() => onPreviousItemClick()}
                label="<"
                className="btn btn-primary margin-xs-right"
                IsDisabled={props.isPreviousButtonDisabled}
                dataCy="previous-button"
            />
            <ButtonControl
                onClick={() => onNextItemClick()}
                label=">"
                className="btn btn-primary margin-sm-right"
                dataCy="next-button"
            />
            {props.itemCount > 0 && (
                <span className="pageIndicator" data-cy="index-of-total">
                    {`${props.absoluteIndex} ${getText("OfLabel")} ${props.itemCount}`}
                </span>
            )}
        </>
    );
}

export { IPaginationViewControlProps, PaginationViewControl };
